import { useFormik } from "formik";
import * as Yup from "yup";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { useState, useEffect, useRef } from "react";
import ComplaintService from "../../services/complaint/ComplaintService";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { useNavigate } from "react-router-dom";
import { ImageTemplateDemo } from "../images/file-upload-template";

interface CustomerServComplaintRegisterProps {
  visible: boolean;
  onHide: () => void;
  onSuccess?: () => void;
}

const CustomerServComplaintRegister: React.FC<CustomerServComplaintRegisterProps> = ({ 
  visible, 
  onHide,
  onSuccess 
}) => {
  const [imageFile, setImageFile] = useState<any>(null);
  const toast = useRef<Toast>(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [loginUser, setLoginUser] = useState<any>(null);
  const navigate = useNavigate();
  const [containerType, setContainerType] = useState<string>("Complaints");
  
  const initialValues = {
    description: "",
    image: null as string | null,
    video: null as string | null,
    severity: null as string | null,
    remarks: null as string | null,
    customerSupportAction: null as string | null,
  };

  const validationSchema = Yup.object({
    description: Yup.string().required("Description is required"),
  });

  useEffect(() => {
    const LoginDetails = localStorage.getItem('user');
    if (LoginDetails) {
      const user = JSON.parse(LoginDetails);
      setLoginUser(user);
    }
  }, []);

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: async (data) => {
      if (isSubmitted) return;
      setIsSubmitted(true);
      const complaint = {
        CustomerId: loginUser?.userID || 0,
        Description: data.description,
        Image: data.image,
        Severity: data.severity,
        Remarks: data.remarks,
        CustomerSupportAction: data.customerSupportAction,
        CreatedBy: loginUser?.userID || 0,
        CreatedDate: new Date().toISOString(),
        ContainerType : containerType
      };

      try {
        const response = await ComplaintService.CreateCustomerServiceComplaint(complaint);
        
        if (response.isSuccess) {
          showMessage('Success', 'Service complaint created successfully', 'success');
          //navigate('/CustomerComplaintMain');
          navigate('/CustomerComplaintMain', { state: { complaintType: 'service' } });
          formik.resetForm();
          setImageFile(null);
          onHide();
          onSuccess?.();
        } else {
          showMessage('Error', response.message, 'error');
        }
      } catch (error) {
        console.error("Error during service complaint submission", error);
        showMessage('Error', 'Failed to create service complaint', 'error');
      } finally {
        setIsSubmitted(false);
      }
    },
  });

  const showMessage = (label: string, message: string, severity: 'success' | 'error' | 'info' | 'warn') => {
    toast.current?.show({ severity, summary: label, detail: message, life: 3000 });
  };

  const renderDescriptionField = () => (
    <div className="field col-12 mb-4">
      <label htmlFor="description" style={{ fontWeight: 'bold' }}>
        Description<span style={{ color: "red" }}>*</span>
      </label>
      <InputTextarea
        placeholder="Enter Description"
        name="description"
        id="description"
        rows={5}
        className="w-full"
        value={formik.values.description}
        onChange={(e) => {
                          const cleanedValue = e.target.value.replace(/\s\s+/g, ' ');
                           formik.setFieldValue('description', cleanedValue);
                          }}
        style={{border:"1px solid gray"}}
      />
      {formik.errors.description && formik.touched.description && (
        <small className="p-error">{formik.errors.description as string}</small>
      )}
    </div>
  );

  const renderButtons = () => (
    <div className="field col-12 flex justify-content-end gap-8">
      <Button 
        type="button" 
        label="Reset" 
        className="p-button-secondary" 
        onClick={() => formik.resetForm()} 
      />
      <Button 
        type="submit" 
        label="Raise Complaint" 
        className="p-button-primary" 
        disabled={isSubmitted}
      />
    </div>
  );

    const handleFileUpload = (file: any) => {
    setImageFile(file);
    formik.setFieldValue("image", file);
  };

    const handleFileSizeExceeded = (message: string) => {
    showMessage('Info', message, 'info');
  };

  return (
    <>
      <Toast ref={toast} position="top-center" />
      <Dialog 
        visible={visible} 
        onHide={onHide}
        modal
        className="p-fluid responsive-dialog"
      >
        <h5 className='order-top-color p-2 panel-header-text text-center shadow-3'>
          Service Complaint Registration
        </h5>
        <form onSubmit={formik.handleSubmit} className="p-grid p-fluid">
          {renderDescriptionField()}
          <ImageTemplateDemo onFileUpload={handleFileUpload} handelFileSize={handleFileSizeExceeded} />
          {renderButtons()}
        </form>
      </Dialog>
    </>
  );
};

export default CustomerServComplaintRegister;